import NumberFormat from 'react-number-format';

export function CurrencyFormatInput(props: { [x: string]: any; name?: any; inputRef?: any; onChange?: any; }) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="$"
        />
    );
}

export function PercentFormatInput(props: { [x: string]: any; name?: any; inputRef?: any; onChange?: any; }) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            decimalScale={4}
            allowNegative={false}
            suffix="%"
        />
    );
}


export function GenericThousandFormatInput(props: { [x: string]: any; name?: any; inputRef?: any; onChange?: any; }) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            allowNegative={false}
            // format="#### #### #### ####" 
            thousandSeparator=" "
        />
    );
}

export function SerialFormat(props: { [x: string]: any; name?: any; inputRef?: any; onChange?: any; }) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            allowNegative={false}
            format="### ###"
            thousandSeparator=" "
        />
    );
}

// import { format, utcToZonedTime } from "date-fns-tz";
export const dateLocales = 'es'
export const currencyLocales = 'en'
export const numberLocales = 'en'

export const defautlDateFormatString = "DD/MM/YYYY"
export const defautlDateTimeFormatString = "DD/MM/YYYY HH:mm:ss"
export const defautlTimeFormatString = "HH:mm:ss"


export const defaultDateOptions = {
    timeZone: 'UTC'
}

export const defaultCurrencyOptions = {
    style: "currency",
    currency: 'USD',
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    // maximumSignificantDigits: 0
}

export const defaultPercentOptions = {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
}

export const currencyFormatter = (locales = currencyLocales, options?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat(locales, {
        ...options,
        ...defaultCurrencyOptions,
    });

export const dateFormatter = (locales = dateLocales, options?: Intl.DateTimeFormatOptions) =>
    new Intl.DateTimeFormat(locales, {
        ...options,
        ...defaultDateOptions,
    })

export const percentFormatter = (locales = numberLocales, options?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat(locales, {
        ...options,
        ...defaultPercentOptions,
    })

export const formatMoney = (number: number, divisor = 100) => {
    return currencyFormatter().format(number / divisor);
};

export const formatDate = (date: Date, options?: Intl.DateTimeFormatOptions) => {
    return dateFormatter().format(new Date(date))
};

export const formatPercentage = (number: number) => {
    return percentFormatter().format(number)
}

export const formatMoneyMills = (number: number) => {
    return `$${(number / 100).toFixed()}`
}
export const formatMoneyThou = (number: number) => {
    return `$${number / 100000}K`
}

export const formatMoneyEstimate = (number: number) => {
    if (number > 999999) {
        return formatMoneyMills(number)
    } else {
        return formatMoneyThou(number)
    }
}
